import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-login-comp',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  @Output()
  loginEvent = new EventEmitter<{
    userid: string;
    password: string;
    remember_me: boolean;
  }>();

  @Input()
  error: string = '';

  checked = true;
  loginForm: FormGroup;
  show: boolean = false;

  constructor() {
    this.loginForm = new FormGroup({
      userid: new FormControl('', [
        Validators.required,
        Validators.pattern(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),
      ]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(20),
      ]),
      remember_me: new FormControl(true),
    });
  }

  ngOnInit(): void {}

  toggleShow() {
    this.show = !this.show;
  }

  get f() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.loginEvent.emit(this.loginForm.value);
  }

  onChange() {
    this.error = '';
  }
}
